import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { routes } from './router/Routes';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import BookingNavbar from './features/booking/components/BookingNavbar';
import Footer from './components/Footer';
import { NavbarProvider } from './context/NavbarContext';
import { useState, useEffect } from 'react';
import Splash from './components/Splash';
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { initGA } from './utils/analytics';
import { setupErrorFiltering } from './utils/domUtils';
import { trackWebVitals, monitorThirdPartyScripts, trackConsoleErrors } from './utils/performance';
import usePageTracking from './hooks/usePageTracking';
import ErrorBoundary from './components/ErrorBoundary';
import SEO from './components/SEO';
import CookieConsentBanner from './components/CookieConsentBanner';
import { Suspense } from 'react';

// Layout wrapper component to handle both Navbar and Footer
function LayoutWrapper() {
  const location = useLocation();
  // Booking route kontrolü - sadece randevu oluşturma sayfaları için BookingNavbar
  const isBookingRoute = (
    location.pathname.includes('/booking') || 
    (location.pathname.includes('/randevu') && 
     !location.pathname.includes('/randevu-sorgula') && 
    !location.pathname.match(/^\/randevu\/[^/]+$/)) // /randevu/:code formatını hariç tut
  );
  
  // Page tracking hook'unu burada kullan
  usePageTracking();
  
  return (
    <>
      <SEO path={location.pathname} />
      {isBookingRoute ? <BookingNavbar /> : <Navbar />}
      <Suspense fallback={null}>
        <Routes>
          {routes.map((route, index) => (
            <Route
              key={index}
              path={route.path}
              element={
                <>
                  {route.element}
                  {!isBookingRoute && <Footer />}
                </>
              }
            />
          ))}
        </Routes>
      </Suspense>
    </>
  );
}

function App() {
  const [isLoading] = useState(false);

  useEffect(() => {
    // Setup error filtering for third-party extensions
    setupErrorFiltering();
    
    // Google Analytics'i başlat
    initGA();
    
    // Initialize performance monitoring
    trackWebVitals();
    monitorThirdPartyScripts();
    trackConsoleErrors();
    
    // No artificial loading delay in production path.
    return undefined;
  }, []);

  return (
    <HelmetProvider>
      <AuthProvider>
        <NavbarProvider>
          <ErrorBoundary>
            {isLoading && <Splash />}
            {!isLoading && (
              <BrowserRouter>
                <ScrollToTop />
                <LayoutWrapper />
                <CookieConsentBanner />
              </BrowserRouter>
            )}
            <ToastContainer
              position="bottom-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              transition={Slide}
            />
          </ErrorBoundary>
        </NavbarProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
